export default "__VITE_ASSET__ebdbf3ec__"